module.exports = __webpack_public_path__ + "img/features-actor-studio-overview.189fd4a5.png";